import { Spacing } from 'UI'

export default {
  container: {
    margin: Spacing(0, 0, 10, 0)
  },
  main: {
    margin: Spacing(0, 0, 6, 0)
  }
}
